var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCode({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 235,
    viewBox: "0 0 275 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.769 5C34.5575 5 25.3845 14.173 25.3845 25.3845V96.7302C25.3845 107.942 16.2115 117.115 5 117.115C16.2115 117.115 25.3845 126.288 25.3845 137.499V208.845C25.3845 220.056 34.5575 229.229 45.769 229.229",
    stroke: "#343434",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M229.231 5C240.443 5 249.616 14.173 249.616 25.3845V96.7302C249.616 107.942 258.789 117.115 270 117.115C258.789 117.115 249.616 126.288 249.616 137.499V208.845C249.616 220.056 240.443 229.229 229.231 229.229",
    stroke: "#343434",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7349 86.5422L66.1582 117.119L96.7349 147.696",
    stroke: "#343434",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M178.263 86.5422L208.839 117.119L178.263 147.696",
    stroke: "#343434",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M147.678 76.3247L127.294 157.863",
    stroke: "#343434",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.36c40135f11d023e736f105862137c98.svg";
export { ForwardRef as ReactComponent };